import React, { useEffect, useState } from "react";
import {
  IonModal,
  IonCard,
  IonCardHeader,
  IonCol,
  IonCardContent,
  IonRow,
  IonToast,
  IonImg,
  IonIcon,
  IonGrid,
  IonButton,
  IonInput
} from "@ionic/react";
import { IStopReferenceProps } from "../../../schemas/StartTrip/StartTrip";
import {
  REFERENCE,
  NO_REFERENCE_MSG,
  ALL_FIELDS_REQUIRED_TEXT,
  ADD_REFERENCE_SUCCESS,
  REFERENCE_ACTION_TYPE,
  REFERENCE_ACTION_DETAIL,
  REFERENCE_TYPE_HEADER_MESSAGE,
  REFERENCE_TYPE_MESSAGE,
  REFERENCE_VALUE_PLACEHOLDER_MESSAGE
} from "../../../utils/constants";
import { EVENT, SCREEN } from "../../../utils/constants.analytics";
import { logEvent, setScreenName } from "../../../utils/Analytics";

import "./referenceDialogWeb.scss";
import i18n from "../../../../i18n";
import { CustomModalWeb } from "app/web/pages/userProfile/CustomModalWeb";
import { isAddReferencesVisible, referencesDropdownButtons } from "app/utils/sourceTMSAndDivisionFilter";
import { AddReferences } from "app/models/myLoad/tenderAction.model";
import { addReference } from "app/actions/carrierTendered/action";
import { getCurrentDatewithTimeZone, getCustomer } from "app/pages/LoadDetails/loadDetailsUtil";
import { useDispatch } from "react-redux";
import { GetShipment } from "app/models/home/GetShipment.model";
import { buyLoadShipmentRequest } from "app/actions/BookLoad/action";
import { useLocation } from "react-router";
import { isDispatcherRole, isDriverRoleOnly, isLeasedOwnerOprRoleOnly } from "../../../utils/roleUtil/RoleUtil";

export const ReferenceDialogWeb: React.FunctionComponent<IStopReferenceProps> = (
  props: IStopReferenceProps
) => {
  const [referenceModal, setReferenceModal] = React.useState(false);
  const [addReferenceModal, setAddReferenceModal] = React.useState(false);
  const [showOptions, setShowOptions] = useState<number | null>(null);
  const [selectedDropdown, setSelectedDropdown] = React.useState([{ refType: '', refVal: ''}]);
  const [isError, setIsError] = useState<string | null>(null);
  const [showToast, setShowToast] = React.useState(false);
  const { stopDetail, shipment } = props;
  const dispatch = useDispatch();
  const location = useLocation();
  const stopReference = stopDetail?.stopReference?.length
      ? stopDetail.stopReference
      : [];
  const shipmentReference =
    shipment?.shipmentReferences?.length
      ? shipment.shipmentReferences
      : [];
  const shipmentandStopReferences =  stopDetail?.shipmentAndStopReferences?.length
  ? stopDetail.shipmentAndStopReferences
  : [];
  const references = shipmentandStopReferences;
  const addReferencesOptions = referencesDropdownButtons(props?.shipment?.sourceTMS,props?.shipment?.division)?.sort();
  const referenceClick = (): void => {
    if(props?.shipment?.sourceTMS || props?.shipment?.division){
      setReferenceModal(true);
    } else if (isAddReferencesVisible(props?.shipment?.sourceTMS,props?.shipment?.division)){
      setReferenceModal(true);
    } else {
      setShowToast(true);
    }
  };
  const closeReferenceModal = (): void => {
    setReferenceModal(false);
  };
  // Analytics implementation
  useEffect(() => {
    setScreenName(SCREEN.SCREEN_REFERENCE_DIALOG);
    logEvent(EVENT.SV_VIEW_REFERENCE, {
      screen: SCREEN.MYLOADS_NEEDS_PPWK,
      carrierId: props?.carrierId,
      shipmentId: shipment?.shipmentId,
      stopId: props?.stopDetail?.stopId
    });
  }, []);

  const addReferenceProps = {
    isModalOpen:  !!addReferenceModal,
    title: "Add Reference",
    contentAlignment: "center",
    aditionalCssClass : "",
    size: "medium_small",
    contentScroll: "allow",
    backdropDismiss:false,
    buttons: [
      {
        title: i18n.t('Cancel'),
        type: "secondary-cta-btn-web",
        onClick: () => {
          logEvent(EVENT.UE_ADD_REFERENCE_CANCEL, {
            screen: SCREEN.ADD_REFERENCE_MODAL,
            carrierId: props?.carrierId,
            shipmentId: shipment?.shipmentId,
            stopId: props?.stopDetail?.stopId
          });
          setAddReferenceModal(false);
          setSelectedDropdown([{ refType: '', refVal: ''}]);
          referenceClick();
        }
      },
      {
        title: i18n.t('Confirm'),
        type: "primary-cta-btn-web",
        isDisabled: selectedDropdown.some((item) => item.refType === '' || item.refVal === '') ? true : false,
        onClick: () => {
          setIsError(null);
          logEvent(EVENT.UE_ADD_REFERENCE_CONFIRM, {
            screen: SCREEN.ADD_REFERENCE_MODAL,
            carrierId: props?.carrierId,
            shipmentId: shipment?.shipmentId,
            stopId: props?.stopDetail?.stopId
          });
          setAddReferenceModal(false);
          const _model: any = new AddReferences();
          _model.shipmentId = shipment?.shipmentId;
          _model.sourceSystem = shipment?.sourceTMS;
          _model.eventDateTime = getCurrentDatewithTimeZone(shipment?.loadStop);
          _model.customer = getCustomer(shipment?.shipmentInvolvedParties);
          _model.assignmentStatus = shipment?.assignmentStatus;
          _model.actionType = REFERENCE_ACTION_TYPE;
          _model.actionQualifier = selectedDropdown[0]?.refType;
          _model.actionDetail = REFERENCE_ACTION_DETAIL;
          _model.shipmentState = shipment?.shipmentState || null;
          _model.actionDateTime = null;
          _model.referenceType = selectedDropdown[0]?.refType;
          _model.referenceValue = selectedDropdown[0]?.refVal;
          const module = (location?.state && (location.state as any).module) || "#";
          dispatch(addReference(_model.getAddReferenceActionPayload(),false, async (response: any) => {
          if (response.message === ADD_REFERENCE_SUCCESS) {
            setShowToast(true); //on true response
            logEvent(EVENT.UE_ADD_REFERENCE_SUCCESS, {
              screen: SCREEN.ADD_REFERENCE_MODAL,
              carrierId: props?.carrierId,
              shipmentId: shipment?.shipmentId,
              stopId: props?.stopDetail?.stopId
            });
            const shipmentId = (shipment?.shipmentId);
            const getShipmentmodel: GetShipment = new GetShipment();
            getShipmentmodel.shipmentIds = shipmentId;
            dispatch(
              buyLoadShipmentRequest({
                query: getShipmentmodel.getRequestShipmentPayload(),
                shipmentId,
                module: module,
                isPullToRefresh: true,
              })
            );
          } else {
            logEvent(EVENT.UE_ADD_REFERENCE_FAILURE, {
              screen: SCREEN.ADD_REFERENCE_MODAL,
              carrierId: props?.carrierId,
              shipmentId: shipment?.shipmentId,
              stopId: props?.stopDetail?.stopId
            }); //on error response
          }
          }));
          setSelectedDropdown([{ refType: '', refVal: ''}]);
        }
      }
    ]
  };

  const onConfirm = (option: any, refIndex: number) => {
    const onChangeOption = [...selectedDropdown];
    onChangeOption[refIndex].refType = option;
    setSelectedDropdown(onChangeOption);
    setShowOptions(null);
    isError && errorCheckHandler();
  };

  const handleChange = (e?: any,i?:any) => {
    const {value} = e.target;
    const onChangeVal = [...selectedDropdown];
    onChangeVal[i].refVal=value;
    setSelectedDropdown(onChangeVal);
    errorCheckHandler();
  };

  const errorCheckHandler = () => {
    const hasEmptyFields = selectedDropdown.some((item) => item.refType === '' || item.refVal === '');
    if (hasEmptyFields) {
      if (selectedDropdown[selectedDropdown.length - 1].refType === '') {
        selectedDropdown.some((item) => item.refType === '' && item.refVal === '') ? setIsError(null) : setIsError('TypeError');
      } else if (selectedDropdown[selectedDropdown.length - 1].refVal === '') {
        setIsError('ValueError');
      }
    } else {
      setIsError(null);
    }
  };
  
  return (
    <div className="referenceDialogWebContainer">
      <CustomModalWeb {...addReferenceProps}>
        <IonGrid className="reference-modal-grid">
          <IonRow className="reference-heading">
            <div className="reference-type-heading">{REFERENCE_TYPE_HEADER_MESSAGE}</div>
            {selectedDropdown?.map((value, i: number) => (
              <IonRow key={i} className="reference-head">
                <IonCol size="6">
                  <div className="ref-type">{"Select Type"}</div>
                  <IonButton
                    className={`dropdown-button ${isError === 'TypeError' ? "error-border" : ""}`}
                    data-test="reference-type"
                    onClick={() => {
                      setShowOptions(i);
                    }}>
                    <span className={`${value?.refType ? "selected-dropdown-name" : "placeholder" }`}>{value?.refType ? `${value.refType}` : REFERENCE_TYPE_MESSAGE}</span>
                    <i className="down"></i>
                  </IonButton>
                </IonCol>
                <IonCol size="6">
                  <div className="ref-value">{"Select Value"}</div>
                  <IonInput
                    type="text"
                    className={`reference-input ${isError === 'ValueError' ? "error-border" : ""}`}
                    placeholder={REFERENCE_VALUE_PLACEHOLDER_MESSAGE}
                    name={"referenceValue"}
                    maxlength={25}
                    onIonChange={(e: any) => { handleChange(e,i) }}
                    value={value?.refVal}
                  ></IonInput>
                </IonCol>
              </IonRow>))}
            {(showOptions !== null) ? (
              <div className="dropdown-list" data-test="dropdown-options" onMouseLeave={() => setShowOptions(null)}>
                {addReferencesOptions?.map((option: any, k: any) => (
                  <IonRow data-test="dropdown-row" key={k} onClick={() => { onConfirm(option, showOptions) }}>
                    <IonCol>{option}</IonCol>
                  </IonRow>
                ))}
              </div>
            ) : null}
            {isError && <span className="red-error">{ALL_FIELDS_REQUIRED_TEXT}</span>}
          </IonRow>
        </IonGrid>
      </CustomModalWeb>
      {referenceModal && (
        <>
          <IonModal
            isOpen={referenceModal}
            cssClass={`dropdown-modal reference-dialog-web`}
            backdropDismiss={false}
            onDidDismiss={() => closeReferenceModal()}
          >
            <div data-test="modal-div">
              <IonCard className="referencemodal-card">
                <IonCardHeader className="start-trip-cardContent">
                  <IonRow>
                    <IonCol size="11">{i18n.t("References Details")}</IonCol>
                    <IonCol size="1">
                      <IonIcon
                        className="close"
                        onClick={() => closeReferenceModal()}
                        src="assets/icon/close.svg"
                      />
                    </IonCol>
                  </IonRow>
                </IonCardHeader>
                {!!references.length ? references.length === 1 ? references[0].display ? (
                  <>
                  <IonCardContent  class="reference-data-container" >
                    <IonGrid className="references-title-component">
                      <IonRow>
                        <IonCol
                          data-test="Reference-Type"
                          className={"web-padding"}
                        >
                          {i18n.t("Reference Type")}
                        </IonCol>
                        <IonCol
                          data-test="Reference-Value"
                          className={"web-padding"}
                        >
                          {i18n.t("Reference Value")}
                        </IonCol>
                      </IonRow>
                    </IonGrid>
                    <div className="reference-item-container">
                      {references.map((ref: any, index: number) => (
                       ref.display &&  <IonGrid
                          className="references-component"
                          key={`${ref.type}_${index}`}
                        >
                          <IonRow>
                            <IonCol
                              data-test="description"
                              className={"web-padding"}
                            >
                              {ref.type}
                            </IonCol>
                            <IonCol
                              data-test="packaging-type"
                              className={"web-padding"}
                            >
                              {ref.value}
                            </IonCol>
                          </IonRow>
                        </IonGrid>
                      ))}
                    </div>
                  </IonCardContent>
                  {(isAddReferencesVisible(props?.shipment?.sourceTMS,props?.shipment?.division) && (isLeasedOwnerOprRoleOnly() || isDispatcherRole() || isDriverRoleOnly()))  ?              
                    <IonRow className="reference-header">
                      <IonGrid className="add-references" data-test="add-reference-button" onClick={() => {
                        closeReferenceModal();
                        setAddReferenceModal(true);
                        setIsError(null);
                        logEvent(EVENT.SV_ADD_REFERENCE, {
                          screen: SCREEN.ADD_REFERENCE_MODAL,
                          shipmentId: shipment?.shipmentId,
                          stopId: props?.stopDetail?.stopId
                        });
                      }}>
                        <IonIcon
                          className="add-ref-icon"
                          src="assets/icon/reference-template.svg"
                        />
                        <div>{i18n.t("Add Reference")}</div>
                      </IonGrid>
                    </IonRow> : null}
                  </>
                ) : <IonCard class="no-references-found">
                <IonCardContent>
                  <div>{i18n.t("noReferencesText")}</div>
                </IonCardContent>
              </IonCard> : <>
                <IonCardContent  class="reference-data-container" >
                  <IonGrid className="references-title-component">
                    <IonRow>
                      <IonCol
                        data-test="Reference-Type"
                        className={"web-padding"}
                      >
                        {i18n.t("Reference Type")}
                      </IonCol>
                      <IonCol
                        data-test="Reference-Value"
                        className={"web-padding"}
                      >
                        {i18n.t("Reference Value")}
                      </IonCol>
                    </IonRow>
                  </IonGrid>
                  <div className="reference-item-container">
                    {references.map((ref: any, index: number) => (
                     ref.display && <IonGrid
                        className="references-component"
                        key={`${ref.type}_${index}`}
                      >
                        <IonRow>
                          <IonCol
                            data-test="description"
                            className={"web-padding"}
                          >
                            {ref.type}
                          </IonCol>
                          <IonCol
                            data-test="packaging-type"
                            className={"web-padding"}
                          >
                            {ref.value}
                          </IonCol>
                        </IonRow>
                      </IonGrid>
                    ))}
                  </div>
                </IonCardContent>
                {(isAddReferencesVisible(props?.shipment?.sourceTMS,props?.shipment?.division) && (isLeasedOwnerOprRoleOnly() || isDispatcherRole() || isDriverRoleOnly()))  ?              
                  <IonRow className="reference-header">
                    <IonGrid className="add-references" data-test="add-reference-button" onClick={() => {
                      closeReferenceModal();
                      setAddReferenceModal(true);
                      setIsError(null);
                      logEvent(EVENT.SV_ADD_REFERENCE, {
                        screen: SCREEN.ADD_REFERENCE_MODAL,
                        shipmentId: shipment?.shipmentId,
                        stopId: props?.stopDetail?.stopId
                      });
                    }}>
                      <IonIcon
                        className="add-ref-icon"
                        src="assets/icon/reference-template.svg"
                      />
                      <div>{i18n.t("Add Reference")}</div>
                    </IonGrid>
                  </IonRow> : null}
                </>: (
                  <>
                  {(isAddReferencesVisible(props?.shipment?.sourceTMS,props?.shipment?.division) && (isLeasedOwnerOprRoleOnly() || isDispatcherRole() || isDriverRoleOnly())) &&             
                    <IonRow className="reference-header">
                      <IonGrid className="add-references" data-test="add-reference-button" onClick={() => {
                        closeReferenceModal();
                        setAddReferenceModal(true);
                        setIsError(null);
                        logEvent(EVENT.SV_ADD_REFERENCE, {
                          screen: SCREEN.ADD_REFERENCE_MODAL,
                          shipmentId: shipment?.shipmentId,
                          stopId: props?.stopDetail?.stopId
                        });
                      }}>
                        <IonIcon
                          className="add-ref-icon"
                          src="assets/icon/reference-template.svg"
                        />
                        <div>{i18n.t("Add Reference")}</div>
                      </IonGrid>
                    </IonRow>}
                  <IonCard class="no-references-found">
                    <IonCardContent>
                      <div>{i18n.t("noReferencesText")}</div>
                    </IonCardContent>
                  </IonCard>
                  </>
                )}
              </IonCard>
            </div>
          </IonModal>
        </>
      )}
      {props?.stopDetail?.shipmentAndStopReferences?.length === 0 ? <IonToast
        isOpen={showToast}
        message={NO_REFERENCE_MSG}
        duration={5000}
        color="dark"
        onDidDismiss={() => {
          setShowToast(false);
        }}
        mode="md"
      /> : <IonToast
        isOpen={showToast}
        message={ADD_REFERENCE_SUCCESS}
        duration={5000}
        color="dark"
        onDidDismiss={() => {
          setShowToast(false);
        }}
        mode="md"
      />}
      <div className="referenceBtnContainer" data-testid="referenceBtnContainer" onClick={referenceClick}>
        <h3 className={`reference-dialog-action`}>{REFERENCE} </h3>
        <IonImg className="forward-icon" src="assets/icon/down arrow@2x.png" />
      </div>
    </div>
  );
};
